import { FETCH_VENUES_SUCCEEDED, SELECT_VENUE, FETCH_VENUE_REQUESTED } from './constants'

import api from '../../utils/api'

export const fetchVenuesRequested = () => ({
  type: FETCH_VENUE_REQUESTED
})

export const fetchVenues = () => dispatch => {
  dispatch(fetchVenuesRequested())

  return api
    .fetchVenues()
    .then(({ data }) => dispatch(fetchVenuesSucceeded(data)))
}

export const selectVenue = venueUuid => ({
  type: SELECT_VENUE,
  payload: venueUuid,
})

export const fetchVenuesSucceeded = venues => ({
  type: FETCH_VENUES_SUCCEEDED,
  payload: venues,
})
